import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Mission } from "@/components/site/Mission";
import { Studio } from "@/components/site/Studio";
import { Bento } from "@/components/site/Bento";
import { Lookbook } from "@/components/site/Lookbook";
import { Support } from "@/components/site/Support";
import { SpeakUp } from "@/components/site/SpeakUp";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Mission />
      <Studio />
      <Bento />
      <Lookbook />
      <Support />
      <SpeakUp />
      <Footer />
    </main>
  );
}
